import React, { useEffect, useState } from "react";
import styles from "./time-interval-input-and-dropdown-wrapper.module.scss";
import {
  TimeUnit,
  translateTime,
} from "@src/cloud-connect/utils/translate-time";
import { useI18N } from "@src/language/language-context";

interface TimeIntervalTypes {
  value: number;
  unit: TimeUnit;
}
interface TimeIntervalInputAndDropDownWrapperPropTypes {
  intervalInSeconds: number;
  callback: (timeIntervalInSeconds: number) => void;
}

const cssClassName = "time-interval-input-and-dropdown-wrapper";
const defaultTimeUnit = TimeUnit.Seconds;
const defaultTimeValue = 0;
const timeUnits = ["Seconds", "Minutes", "Hours", "Days"];

export const TimeIntervalInputAndDropDownWrapper = ({
  intervalInSeconds,
  callback,
}: TimeIntervalInputAndDropDownWrapperPropTypes) => {
  const i18n = useI18N();
  const [previousTimeUnit, setPreviousTimeUnit] =
    useState<TimeUnit>(defaultTimeUnit);
  const [timeInterval, setTimeInterval] = useState<TimeIntervalTypes>({
    value: intervalInSeconds,
    unit: defaultTimeUnit,
  });

  const texts = {
    secondsLabel: i18n(
      "modules.timeIntervalInputAndDropDownWrapper.secondsLabel",
    ),
    minutesLabel: i18n(
      "modules.timeIntervalInputAndDropDownWrapper.minutesLabel",
    ),
    hoursLabel: i18n("modules.timeIntervalInputAndDropDownWrapper.hoursLabel"),
    daysLabel: i18n("modules.timeIntervalInputAndDropDownWrapper.daysLabel"),
  };

  const timeUnitsLabels = [
    texts.secondsLabel,
    texts.minutesLabel,
    texts.hoursLabel,
    texts.daysLabel,
  ];

  const convertBackInSeconds = (timeValue, timeUnit) => {
    const intervalInSeconds = translateTime(
      timeUnit,
      defaultTimeUnit,
      timeValue,
    );

    callback(intervalInSeconds);
  };

  const stringToNumber = (timeIntervalValueString) => {
    return Number(timeIntervalValueString.replace(/\D/g, ""));
  };

  const handleChangeTimeValue = (timeIntervalValueString: string) => {
    const timeIntervalValue = stringToNumber(timeIntervalValueString);
    setTimeInterval({ ...timeInterval, value: timeIntervalValue });
  };

  const handleBlurTimeValue = (timeIntervalValueString) => {
    const timeIntervalValue = stringToNumber(timeIntervalValueString);
    convertBackInSeconds(timeIntervalValue, timeInterval.unit);
  };

  const handleChangeTimeUnit = (timeIntervalueUnit) => {
    const newInterval = translateTime(
      previousTimeUnit,
      timeIntervalueUnit,
      timeInterval.value,
    );

    setTimeInterval({ value: newInterval, unit: timeIntervalueUnit });
    convertBackInSeconds(newInterval, timeIntervalueUnit);
    setPreviousTimeUnit(timeIntervalueUnit);
  };

  useEffect(() => {
    setTimeInterval({ value: intervalInSeconds, unit: TimeUnit.Seconds });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles[cssClassName]}>
      <input
        placeholder={`${defaultTimeValue}`}
        value={timeInterval.value}
        onChange={(e) => handleChangeTimeValue(e.target.value)}
        onBlur={(e) => handleBlurTimeValue(e.target.value)}
        className={styles[`${cssClassName}__input`]}
      />
      <select
        value={timeInterval.unit}
        onChange={(e) => handleChangeTimeUnit(e.target.value)}
        className={styles[`${cssClassName}__dropdown`]}
      >
        {timeUnits.map((unit, index) => (
          <option key={unit} value={unit}>
            {timeUnitsLabels[index]}
          </option>
        ))}
      </select>
    </div>
  );
};
